var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"staff_manage"}},[(_vm.tabshow)?_c('div',[_c('v-class')],1):_vm._e(),_vm._v(" "),_c('v-reading',{attrs:{"showflag":_vm.readingflag},on:{"update:showflag":function($event){_vm.readingflag=$event},"hidden":_vm.closecharge}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50c704df","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/register/register.vue
// module id = null
// module chunks = 